import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { RoleHistoryList, LoadingOverlay, FullHeightContainerLayout } from "components";
import { showError } from 'common/ToastNotifications';
import { withRouter } from "react-router";
import _ from 'lodash';
import { Row, Col, Typography, Empty } from 'antd';
import AppPaths from 'constants/appPaths';

const { Title, Text } = Typography;

class EventRole extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fetchingData: true
        }
    }

    componentWillMount() {
        if (!this.props.itemOperation) {
            this.setState({
                busy: true,
                busyMessage: "Getting role...",
            });
            this.props.getEventRole(this.props.eventId, this.props.roleId);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetEventRoleResultUpdate(prevProps);
    }

    onGetEventRoleResultUpdate = (prevProps) => {
        if (this.props.getEventRoleResult && this.props.getEventRoleResult !== prevProps.getEventRoleResult) {
            if (!this.props.getEventRoleResult.success) {
                if (this.props.getEventRoleResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get role at this moment.");
                }
            }
            else {
                this.setState({
                    eventListHeight: 36
                })
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingData: false
            });
        }
    }

    isBusy = () => {
        let isBusy = (this.state.busy || this.state.fetchingData);
        return isBusy;
    }

    render() {
        return (
            <>
                {
                    this.isBusy()
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message={this.state.busyMessage || "Please wait..."}>
                        </LoadingOverlay>
                        :
                        <></>
                }
                {
                    !this.state.fetchingData
                        ?
                        <FullHeightContainerLayout
                            showHeader={true}
                            showFooter={false}
                            header={<Title level={5}><Text>Event Revision - </Text><Text type="secondary" italic>{`(Role: ${this.props.roleName})`}</Text></Title>}
                            content={this.props.roleRevision ?
                                <RoleHistoryList
                                    roleRevisions={[this.props.roleRevision]}>
                                </RoleHistoryList>
                                :
                                <Empty></Empty>}>
                        </FullHeightContainerLayout>
                        :
                        <></>
                }
            </>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getEventRoleResult: state.eventRole.getEventRoleResult,
        roleRevision: state.eventRole.roleRevision
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getEventRole: (eventId, roleId) => dispatch(actions.getEventRoleRequest(eventId, roleId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventRole));